<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <div class="">
      <form
        v-if="!retornoPagamento"
        ref="form"
        role="form"
        @submit.stop.prevent="onSubmit"
      >
        <div id="inputs " class="form-transparent   p-0 p-md-3 py-3">
          <div v-if="valorFaltante" class="row">
            <div class="col-sm-12 col-lg-12 p-2 ">
              <p class="alert alert-info">
                Faltam {{ valorFaltante | currency }} para abrir este box
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-lg-12 mt-2 mb-2">
              <label>Valor de carga (mínimo R$20,00)</label>
              <money
                class="form-control input-valor"
                name="Valor"
                id="Valor"
                label="Valor de carga (mínimo R$20,00)"
                v-model="form.valor"
                v-validate="{ required: true, min_value: 20, max_value: 4000 }"
                :state="validateState('Valor')"
                :danger="validateClass('Valor')"
                v-bind="money"
              ></money>
            </div>
          </div>

          <!--h4 class="my-4 pb-4 deskContent" v-if="form.valor >= 20">
            Escolha a forma de Pagamento
          </!--h4>
          <div class="row" v-if="form.valor >= 20">
            <div class="col-sm-12 col-lg-12 mt-2 ">
              <card
                class="cardFinanceiro"
                :class="form.formaPagamento == 'Pix' ? 'card-selecionado' : ''"
                @click.native.stop="form.formaPagamento = 'Pix'"
              >
                <template>
                  <n-radio v-model="form.formaPagamento" label="Pix"
                    ><i class="fa fa-sharp fa-solid fa-qrcode mr-2"></i>Pix</n-radio
                  >
                </template>
              </card>

              <card
                @click.native.stop="form.formaPagamento = 'Cartão de Crédito'"
                :class="
                  form.formaPagamento == 'Cartão de Crédito'
                    ? 'card-selecionado'
                    : ''
                "
              >
                <template>
                  <n-radio
                    v-model="form.formaPagamento"
                    label="Cartão de Crédito"
                    ><i class="fa fa-credit-card mr-2"></i>Cartão de
                    Crédito</n-radio
                  >
                  <CartaoCredito
                    v-if="form.formaPagamento == 'Cartão de Crédito'"
                    @adicionar="confirmaPagamento"
                    :typeCard="'isCartaoAvista'"
                    textoBotao="Confirmar Pagamento"
                    :idUsuario="decoded.idUsuario"
                  ></CartaoCredito>
                </template>
              </card>
            </div>
          </div-->

          <div class="row ">
            <div class="col-sm-12 col-lg-12 text-right">
              <n-button
                v-if="
                  form.formaPagamento != 'Cartão de Crédito' && form.valor >= 5
                "
                nativeType="submit"
                :class="
                  `btnbuscar  btn-primario-formulario ${
                    insideBox ? 'btn-block' : ''
                  } `
                "
                type="success"
                ><i class="fa-duotone fa-sack-dollar mr-1"></i> Adicionar
                Crédito</n-button
              >

              <errosAlert
                :exibeErro="exibeErro"
                :msgErro="msgErro"
                :listaErro="$validator.errors.all()"
              ></errosAlert>
            </div>
          </div>
        </div>
      </form>
      <div v-else class="">
        <!-- PAGAMENTO VIA PIX -->
        <div v-if="retornoPagamento.paymentMethod == 'pix'">
          <h2 class="mt-4  text-center">Pagamento via PIX</h2>
          <div v-if="statusAtualizado" class="text-center">
            <Alert
              type="success"
              title="Atenção!!"
              active="true"
              class="my-3"
              style="height: auto !important"
              >Transação Aprovada com Sucesso, seu saldo foi atualizado!
            </Alert>
            <router-link v-if="!insideBox" to="/" class="btn btn-degrade mt-2">
              Você esta com sorte, comece a abrir os Boxes!
            </router-link>
            <button
              v-else
              @click="comeceAAbrir()"
              class="btn btn-degrade "
              type="button"
              id="button-addon2"
            >
              Você esta com sorte, comece a abrir os Boxes!
            </button>
          </div>
          <div v-else>
            <div class="text-center">
              <VueQr :text="retornoPagamento.transacao.pixQrCode" />
            </div>
            <div class="input-group my-5">
              <div class="input-group-prepend">
                <span class="input-group-text">QR Code</span>
              </div>
              <input
                name="qr code"
                v-model="retornoPagamento.transacao.pixQrCode"
                class="form-control"
              />
              <div class="input-group-append">
                <button
                  @click="copiarQR()"
                  class="btn btn-primario-formulario "
                  type="button"
                  id="button-addon2"
                >
                  <i class="fa-duotone fa-copy"></i> Copiar Qr
                </button>
              </div>
            </div>
            <div>
              <ul>
                <li>
                  1 - Abra o app que você irá realizar o pagamento e escolha
                  pagar via Pix.
                </li>
                <li>
                  2 - Selecione Pagar QR Code e faça o escaneamento usando seu
                  celular.
                </li>
                <li>
                  3 - Você também pode copiar e colar o código Pix na opção Pix
                  Copia e Cola.
                </li>
                <li>4- Confira as informações e autorize o pagamento.</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- PAGAMENTO VIA CARTAO CREDITO -->
        <div v-if="retornoPagamento.paymentMethod == 'creditcard'">
          <h3 class="p-2 p-md-5 text-center">
            Pagamento via Cartão de Crédito
          </h3>
          <div class="text-center">
            <div
              v-if="
                retornoPagamento.galax.Charge.Transactions[0].status == 'denied'
              "
            >
              <Alert
                type="danger"
                title="Atenção!!"
                active="true"
                class="my-3"
                style="height: auto !important"
                >Transação Negada na Operadora
              </Alert>

              <n-button
                @click="retornoPagamento = null"
                class=" btnbuscar    btn-degrade "
                type="success"
                >Tentar Novamente</n-button
              >
            </div>
            <div v-else>
              <Alert
                type="success"
                title="Atenção!!"
                active="true"
                class="my-3"
                style="height: auto !important"
                >Transação Capturada na Operadora com Sucesso, seu saldo foi
                atualizado!
              </Alert>
            </div>
          </div>
        </div>
      </div>

      <div class="" v-if="!insideBox && transacoes.length > 0">
        <hr class="solid" />
        <listarTransacoes
          :transacoes="transacoes"
          @atualiza="atualizaSaldo"
        ></listarTransacoes>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Button,
  Checkbox,
  Radio,
  FormGroupInput,
  Slider,
  Switch,
  Alert,
  Modal,
  Card,
} from '@/components';

import { Popover, DatePicker } from 'element-ui';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import storage from './../../services/storage';
import service from './../../services';
import CartaoCredito from './FormCartaoCredito.vue';
import errosAlert from './errosAlert';
import swal from 'sweetalert';
import { Money } from 'v-money';
import locale from './../../locale';
import VueQr from 'vue-qr';
import listarTransacoes from './listarTransacoes.vue';
//import ws from './../../services/ws';
import { KEY_LOCAL_STORAGE } from './../../const';

export default {
  components: {
    Card,
    errosAlert,
    Alert,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [FormGroupInput.name]: FormGroupInput,
    [Switch.name]: Switch,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Popover.name]: Popover,
    Slider,
    Modal,
    Money,
    CartaoCredito,
    VueQr,
    listarTransacoes,
  },
  props: ['interno', 'insideBox', 'valorFaltante'],
  data() {
    return {
      interval: null,
      idRegistroFinanceiro: null,
      iconeCarregando: service.getEnvIconeCarregando(),
      statusAtualizado: false,
      carregando: false,
      exibeErro: false,
      msgErro: '',
      decoded: {},
      retornoPagamento: null,
      form: {
        valor: 50,
        formaPagamento: 'Pix',
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$',
        suffix: '',
        precision: 2,
      },
      transacoes: [],
      subscribed: null,
    };
  },
  methods: {
    copiarQR() {
      //O texto que será copiado
      const texto = this.retornoPagamento.transacao.pixQrCode;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);

      //swal('=)', 'QR Code foi copiado para a área de Transfêrencia', 'success')
      swal({
        title: '=)',
        text: 'QR Code foi copiado para a área de Transfêrencia',
        type: 'success',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 3000,
        closeOnConfirm: false,
      });
    },
    verificaDecoded() {
      const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);

      if (token) {
        this.decoded = jwt.decode(token);
        if (this.interno) this.buscaTransacoes();
      }
    },
    confirmaPagamento(dados) {
      this.form.idCartao = dados.idCartao;
      this.onSubmit();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (this.veeFields[ref]) {
        if (this.veeFields[ref].dirty) {
          if (this.veeFields[ref].valid == false) {
            return 'has-danger';
          } else {
            return 'has-success';
          }
        }
      }
      return null;
    },
    buscaTransacoes() {
      this.carregando = true;
      service
        .getAll('Usuario', {}, 'ListarFinanceiro')
        .then(res => {
          this.carregando = false;
          this.transacoes =
            res.data && res.data.length
              ? res.data.filter(x => !x.idEncomenda)
              : res.data;
        })
        .catch(error => {
          this.exibeErro = true;
          this.msgErro = 'Não foi possível Listar Transações! \n\n ' + error;
          this.carregando = false;
          swal('ops!', this.msgErro, 'error');
        });
    },
    playCoins() {
      document.getElementById('audio-coins').muted = false;
      document.getElementById('audio-coins').play();
    },
    atualizaSaldo() {
      service
        .getAll('Usuario', {}, 'BuscarSaldo')
        .then(async res => {
          const s = storage.lerStorage(KEY_LOCAL_STORAGE.SALDO);
          storage.escreveStorage(KEY_LOCAL_STORAGE.SALDO, res.data.s);

          if (s != res.data.s) {
            this.$emit('saldoAtualizado');
            this.playCoins();

            // POG
            await this.sleep(2000);

            //this.$router.push(`/thank-you`);
            /* swal({
              title: '=)',
              text: 'Saldo Atualizado com Sucesso',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 3000,
              closeOnConfirm: false,
            });*/
          }

          //this.buscaTransacoes();
        })
        .catch(error => {
          this.exibeErro = true;
          this.msgErro = 'Não foi possível Atualizar Saldo! \n\n ' + error;

          swal('ops!', this.msgErro, 'error');
        });
    },
    sleep(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    },
    async buscaStatusTransacao() {
      console.log('buscaStatusTransacao', this.retornoPagamento);
      let objSend = {};
      objSend.idRegistroFinanceiro = this.retornoPagamento.idRegistroFinanceiro;

      if (!this.statusAtualizado)
        service
          .post('Usuario', 'BuscarStatusTransacao', objSend)
          .then(res => {
            //this.carregando = false;
            if (res.data.idStatus == 5) {
              this.statusAtualizado = true;
              this.disparaEventoFaceFinaliza();
              this.atualizaSaldo();
              this.buscaTransacoes();
            }
          })
          .catch(error => {
            this.exibeErro = true;
            this.msgErro =
              'Não foi possível Buscar Status da Transação! \n\n ' + error;
            //this.carregando = false;
            swal('ops!', this.msgErro, 'error');
          });
    },
    disparaEventoFace() {
      window.fbq('track', 'InitiateCheckout', {
        currency: 'BRL',
        value: this.form.valor,
      });
    },
    disparaEventoFaceFinaliza() {
      window.fbq('track', 'Purchase', {
        currency: 'BRL',
        value: this.form.valor,
      });
    },
    intervalTransacao() {
      this.interval = setInterval(() => {
        this.buscaStatusTransacao();
      }, 10000);
    },
    timeOutTransacao() {
      clearInterval(this.interval);
    },
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.carregando = true;

          let dataVencimento = moment().format('YYYY-MM-DD');
          if (this.form.formaPagamento != 'Cartão de Crédito')
            dataVencimento = moment()
              .add(10, 'days')
              .format('YYYY-MM-DD');

          this.form.dataVencimento = dataVencimento;

          service
            .post('Usuario', 'AdicionaCredito', this.form)
            .then(res => {
              storage.escreveStorage('valorCredito', this.form.valor);
              this.disparaEventoFace();
              this.carregando = false;
              this.exibeErro = false;
              this.retornoPagamento = res.data;
              console.log('retornoPagamento on submit', this.retornoPagamento);
              this.buscaTransacoes();
              this.intervalTransacao();
            })
            .catch(error => {
              this.carregando = false;
              console.log(error);
              if (
                error ==
                'Sua sessão expirou, efetue login novamente para completar a ação'
              ) {
                console.log('dispara erro de login');
                this.$emit('erroLogin');
                return;
              }
              this.exibeErro = true;
              this.msgErro =
                'Não foi possível Adicionar Crédito! \n\n ' + error;

              swal('ops!', this.msgErro, 'error');
            });
        }
      });
    },
    comeceAAbrir() {
      this.retornoPagamento = null;
      this.$emit('CloseModal');
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.verificaDecoded();
    // this.subscribed = ws.subscribe(this.receivedMessageWebSocket);
  },
  beforeDestroy() {
    // ws.unsubscribe(this.subscribed);
    this.timeOutTransacao();
  },
};
</script>
<style scoped>
.input-valor {
  font-size: 26px;
  text-align: center;
}
select {
  padding: 10px !important;
}
input[type='radio'],
input[type='checkbox'] {
  margin-right: 10px !important;
}
.card {
  background-color: transparent !important;
  border-radius: 30px;
  /* color: white;
  box-shadow: 0px 5px 25px 0px rgba(255, 255, 255, 0.2);*/
}
.input-group-text {
  height: 44px;
  padding-right: 10px;
}

.input-group > .input-group-append > .btn {
  margin: 0px;
}

hr {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}
</style>
<style>
.cardCadastro .form-check .form-check-sign::after {
  color: #fff;
}
</style>
